export default __webpack_public_path__ + "static/media/dev.af2e7538.svg";